import { DialogActions, DialogTitle, IconButton, styled } from "@mui/material";

export const ModalTitle = styled(DialogTitle)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: 26,
  fontWeight: 600,
  padding: 0,
  opacity: 1,
});

export const CrossButton = styled(IconButton)({
  position: "absolute",
  top: "10px",
  right: "10px",
});

export const ActionsContainer = styled(DialogActions)({
  gap: "24px",
  padding: 0,
  button: {
    height: "48px",
    padding: "0 24px",
    minWidth: 0,
    margin: 0,
    marginLeft: "0!important",
  },
});
